const methods = inst => ({
    get(key) {
      const v = inst.getItem(key)
      return v !== null ? JSON.parse(v) : v
    },
    set(key, val) {
      if (val === null || val === undefined) {
        return
      }
      inst.setItem(key, JSON.stringify(val))
    },
    remove(key) {
      inst.removeItem(key)
    },
  })
  
  
  const storage = {
    session: methods(window.sessionStorage),
    local: methods(window.localStorage),
  }
  
  export default storage
  